import React from 'react';

const ArrowInicio = ({ variant, ...rest }) => (
  <svg
    width="15"
    height="6"
    viewBox="0 0 15 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.41389 5.80997C7.93656 6.05849 7.35662 6.06355 6.8744 5.82339L0.850832 2.82354C0.0677722 2.43356 -0.228299 1.52495 0.189539 0.794103C0.607378 0.063254 1.5809 -0.213076 2.36396 0.176903L7.61385 2.79145L12.6097 0.190329C13.3848 -0.213239 14.3637 0.0460629 14.7961 0.769496C15.2285 1.49293 14.9507 2.40655 14.1756 2.81012L8.41389 5.80997Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowInicio;
